import { apiSlice } from "./apiSlice.js";
import { 
    ADMIN_AUTHENTICATION_URL,
    ADMIN_LOGOUT_URL,
    ADMIN_REGISTRATION_URL,
    ADMIN_PROFILE_URL,
    ADMIN_USERS_DATA_FETCH_URL,
    ADMIN_ADD_POINT_USER_URL,
    ADMIN_ADD_STAMP_USER_URL,
    ADMIN_CREATE_REWARD_URL,
    ADMIN_UPDATE_REWARD_URL,
    ADMIN_ALL_REWARDS_DATA_URL,
    ADMIN_USERS_REWARDS_DATA_FETCH_URL,
    ADMIN_UPDATE_USER_URL,
    ADMIN_REDEEM_USER_REWARD_URL,
    ADMIN_CHANGE_PASSWORD_URL,
    ADMIN_ALL_DASHBOARD_STATS_URL,
    ADMIN_FETCH_TODAYS_EARNINGS_URL,
    ADMIN_REDEEM_USER_STAMP_REWARD_URL,
    ADMIN_FETCH_TODAYS_STAMPS_EARNINGS_URL,
    ADMIN_VALIDATE_REWARD_TYPE_URL,
} from '../utils/constants.js';

export const adminApiSlice = apiSlice.injectEndpoints({
    
    endpoints: (builder) => ({
        
        adminLogin: builder.mutation({
            
            query: (data) => ({
                url: ADMIN_AUTHENTICATION_URL,
                method: 'POST',
                body: data,
                credentials: 'include',
            }),
        }),
        adminLogout: builder.mutation({
            
            query: () => ({
                url: ADMIN_LOGOUT_URL,
                method: 'POST',
                credentials: 'include',
            }),
        }),
        adminRegister: builder.mutation({
            
            query: (data) => ({
                url: ADMIN_REGISTRATION_URL,
                method: 'POST',
                body: data,
                credentials: 'include',
            }),
        }),
        updateAdmin: builder.mutation({
            
            query: (data) => ({
                url: ADMIN_PROFILE_URL,
                method: 'PUT',
                body: data,
                credentials: 'include',
            }),
        }),
        getUsersData: builder.mutation({
            
            query: () => ({
                url: ADMIN_USERS_DATA_FETCH_URL,
                method: 'POST',
                credentials: 'include',
            }),
        }),
        addPointToUser: builder.mutation({
            
            query: (data) => ({
                url: ADMIN_ADD_POINT_USER_URL,
                method: 'POST',
                body: data,
                credentials: 'include',
            }),
        }),
        addStampToUser: builder.mutation({
            
            query: (data) => ({
                url: ADMIN_ADD_STAMP_USER_URL,
                method: 'POST',
                body: data,
                credentials: 'include',
            }),
        }),
        createReward: builder.mutation({
            
            query: (data) => ({
                url: ADMIN_CREATE_REWARD_URL,
                method: 'POST',
                body: data,
                credentials: 'include',
            }),
        }),
        updateReward: builder.mutation({
            
            query: ({id, data}) => ({
                url: `${ADMIN_UPDATE_REWARD_URL}/${id}`,
                method: 'PUT',
                body: data,
                credentials: 'include',
            }),
        }),
        getAllRewardsData: builder.mutation({

            query: () => ({
                url: ADMIN_ALL_REWARDS_DATA_URL,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        getUsersRewardsData: builder.mutation({

            query: () => ({
                url: ADMIN_USERS_REWARDS_DATA_FETCH_URL,
                method: 'POST',
                credentials: 'include',
            }),
        }),
        redeemUserReward: builder.mutation({
            query: (data) => ({
                url: ADMIN_REDEEM_USER_REWARD_URL,
                method: 'PUT',
                body: data,
                credentials: 'include',
            }),
        }),
        redeemUserStampReward: builder.mutation({
            query: (data) => ({
                url: ADMIN_REDEEM_USER_STAMP_REWARD_URL,
                method: 'PUT',
                body: data,
                credentials: 'include',
            }),
        }),
        updateUserByAdmin: builder.mutation({
            
            query: (data) => ({
                url: ADMIN_UPDATE_USER_URL,
                method: 'PUT',
                body: data,
                credentials: 'include',
            }),

        }),
        updateRewardStatus: builder.mutation({
            
            query: ({id, isActive}) => ({
                url: `${ADMIN_UPDATE_REWARD_URL}/${id}/${isActive}`,
                method: 'PUT',
                credentials: 'include',
            }),
        }),
        userChangedPassword: builder.mutation({
            
            query: (data) => ({
                url: ADMIN_CHANGE_PASSWORD_URL,
                method: 'PUT',
                body: data,
                credentials: 'include',
            }),
        }),
        fetchAdminDashboardStats: builder.mutation({

            query: () => ({
                url: ADMIN_ALL_DASHBOARD_STATS_URL,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        fetchTodaysEarnings: builder.mutation({
            query: (range = 'today') => ({
                url: `${ADMIN_FETCH_TODAYS_EARNINGS_URL}?range=${range}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        fetchTodaysStampsEarnings: builder.mutation({
            query: (range = 'today') => ({
                url: `${ADMIN_FETCH_TODAYS_STAMPS_EARNINGS_URL}?range=${range}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),

        // fetchTodaysEarnings: builder.mutation({

        //     query: () => ({
        //         url: ADMIN_FETCH_TODAYS_EARNINGS_URL,
        //         method: 'GET',
        //         credentials: 'include',
        //     }),
        // }),
        // fetchTodaysStampsEarnings: builder.mutation({
        //     query: () => ({
        //         url: ADMIN_FETCH_TODAYS_STAMPS_EARNINGS_URL,
        //         method: 'GET',
        //         credentials: 'include',
        //     }),
        // }),
        validateRewardType: builder.mutation({
            query: (rewardId) => ({
                url: `${ADMIN_VALIDATE_REWARD_TYPE_URL}/${rewardId}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
    })

})


export const {

    useAdminLoginMutation,
    useAdminLogoutMutation,
    useAdminRegisterMutation,
    useUpdateAdminMutation,
    useGetUsersDataMutation,
    useAddPointToUserMutation,
    useAddStampToUserMutation,
    useCreateRewardMutation,
    useUpdateRewardMutation,
    useGetAllRewardsDataMutation,
    useGetUsersRewardsDataMutation,
    useRedeemUserRewardMutation,
    useRedeemUserStampRewardMutation,
    useUpdateUserByAdminMutation,
    useUpdateRewardStatusMutation,
    useUserChangedPasswordMutation,
    useFetchAdminDashboardStatsMutation,
    useFetchTodaysEarningsMutation,
    useFetchTodaysStampsEarningsMutation,
    useValidateRewardTypeMutation

} = adminApiSlice;